import {PinBuilder} from "cesium";
import {getCesium} from "@/modules/cesium/cesium";
import {getCesiumEntities} from "@/modules/cesium/cesium-entities";

let marker

export function addCesiumMarker(position) {

    const pinBuilder = new PinBuilder();

    removeCesiumMarker()

    marker = getCesiumEntities().add({
        position : position,
        billboard : {
            image : pinBuilder.fromUrl(
                "https://helpdesk.kaartviewer.nl/openiconen/99Test_mapbox/information-15.svg",
                Cesium.Color.RED,
                48
            ),
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            verticalOrigin : Cesium.VerticalOrigin.BOTTOM,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER
        }
    });
}

export function removeCesiumMarker() {
    if(marker) {
        getCesiumEntities().remove(marker);
    }
}
